var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.componentsData.type == 1)?_c('div',[_c('div',{staticClass:"bg-div",style:(_vm.bgStyle)},[(_vm.componentsData.content.title)?_c('div',{staticClass:"title-box",style:(_vm.titleStyle)},[_vm._v(" "+_vm._s(_vm.componentsData.content.title)+" ")]):_vm._e()])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }